<template>
  <report-data-provider :requiredReports="requiredReports" v-model="reports" v-slot:default="{ loading, error, retry }">
    <card-loading v-if="loading" />
    <card-reload v-else-if="error" @reload="retry()"/>
    <procedures-stats v-else :report="report" />
  </report-data-provider>
</template>

<script>
import ReportDataProvider from '@/components/dashboard/ReportDataProvider.vue'
import CardLoading from '@/components/dashboard/CardLoading.vue'
import CardReload from '@/components/dashboard/CardReload.vue'
import ProceduresStats from '@/components/dashboard/efficiency/cards/ProceduresStats.vue'
import { formatPercent } from '@/plugins/consts.js'
import { senseMap } from '@/plugins/colors.js'

export default {
  components: {
    ReportDataProvider,
    CardLoading,
    CardReload,
    ProceduresStats
  },
  data () {
    return {
      requiredReports: ['tendersCount'],
      reports: null
    }
  },
  computed: {
    report () {
      return {
        title: 'Количество новых конкурсов',
        subtitle: 'суммарно за период',
        total: this.reports.tendersCount.total,
        unit: 'шт.',
        procedures: this.procedures,
        proceduresChart: this.proceduresChart
      }
    },
    procedures () {
      const { tendersCount } = this.reports
      return [{
        label: 'С победителем',
        value: tendersCount.withWinner,
        percent: formatPercent(tendersCount.withWinnerPercent),
        color: senseMap.winner
      }, {
        label: 'Несостоявшиеся',
        value: tendersCount.canceled,
        percent: formatPercent(tendersCount.canceledPercent),
        color: senseMap.canceled
      }, {
        label: 'Незавершенные',
        value: tendersCount.incomplete,
        percent: formatPercent(tendersCount.incompletePercent),
        color: senseMap.incomplete
      }].sort((l, r) => {
        return l.value - r.value
      })
    },
    proceduresChart () {
      const { tendersCount } = this.reports
      return {
        hole: [{
          text: 'C победителем',
          value: (data) => formatPercent(tendersCount.withWinnerPercent),
          unit: '%',
          color: senseMap.winner
        }],
        data: this.procedures
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
